import InnerRouter from './InnerRouter';

const AppRouter = () => {
  return <InnerRouter />;
};

export default AppRouter;
